import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Label } from '@smena/ui';
import { PageHeader } from '@/components/PageHeader';
import { Tabs } from '@/components/Tabs';
import { fetchAccounts } from '@/features/accounts/api';
import { AuditTable } from '@/features/troubleshoot/AuditTable';
import { fetchAuditActions } from '@/features/troubleshoot/api';

const SCOPES = [
  { key: 'account', label: 'Журнал аккаунтов' },
  { key: 'admin', label: 'Действия вендора' },
];

export function AuditPage() {
  const [scope, setScope] = useState<'account' | 'admin'>('account');
  const [accountId, setAccountId] = useState('');
  const [action, setAction] = useState('');

  const accountsQ = useQuery({ queryKey: ['accounts'], queryFn: fetchAccounts, staleTime: 60_000 });
  const actionsQ = useQuery({
    queryKey: ['audit-actions'],
    queryFn: fetchAuditActions,
    staleTime: 60_000,
    enabled: scope === 'account',
  });

  return (
    <>
      <PageHeader
        title="Аудит"
        subtitle="История из БД по всем аккаунтам. Ring-буфер панели УК показывает только последние записи одного аккаунта - здесь полная выборка."
      />
      <Tabs
        items={SCOPES}
        value={scope}
        onChange={(k) => {
          setScope(k as 'account' | 'admin');
          setAction('');
        }}
      />
      <div className="mb-4 flex flex-wrap items-end gap-3">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="f-account">Аккаунт</Label>
          <select
            id="f-account"
            value={accountId}
            onChange={(e) => setAccountId(e.target.value)}
            className="h-9 min-w-56 rounded-md border border-line-control bg-input px-2 text-sm text-text"
          >
            <option value="">все</option>
            {accountsQ.data?.map((a) => (
              <option key={a.id} value={a.id}>
                {a.name} ({a.slug})
              </option>
            ))}
          </select>
        </div>
        {scope === 'account' ? (
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="f-action">Действие</Label>
            <select
              id="f-action"
              value={action}
              onChange={(e) => setAction(e.target.value)}
              className="h-9 min-w-56 rounded-md border border-line-control bg-input px-2 text-sm text-text"
            >
              <option value="">все</option>
              {actionsQ.data?.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>
        ) : null}
      </div>
      <AuditTable
        scope={scope}
        {...(accountId ? { accountId } : {})}
        {...(action ? { action } : {})}
      />
    </>
  );
}
